export default __webpack_public_path__ + "static/welcome-img-1e64b4305ee183c5ab780ff6e8deb17c.png";